import { render, staticRenderFns } from "./span.vue?vue&type=template&id=21a007d6&"
import script from "./span.vue?vue&type=script&lang=js&"
export * from "./span.vue?vue&type=script&lang=js&"
import style0 from "./span.vue?vue&type=style&index=0&id=21a007d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports